import { render, staticRenderFns } from "./target-temp.vue?vue&type=template&id=521e77e2&"
var script = {}
import style0 from "./target-temp.vue?vue&type=style&index=0&id=521e77e2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports